export default "__VITE_ASSET__Dy8hp7ST__"